// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file auth/auth_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { LoginDeviceInfo } from './auth_model_pb';
import { file_auth_auth_model } from './auth_model_pb';

/**
 * Describes the file auth/auth_requests.proto.
 */
export const file_auth_auth_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChhhdXRoL2F1dGhfcmVxdWVzdHMucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0ImkKDExvZ2luUmVxdWVzdBIQCgh1c2VybmFtZRgBIAEoCRIQCghwYXNzd29yZBgCIAEoCRI1CgZkZXZpY2UYAyABKAsyJS5jb20uZ2VtLmJmZi5jb250cmFjdC5Mb2dpbkRldmljZUluZm8iYgoTUmVmcmVzaFRva2VuUmVxdWVzdBIUCgxyZWZyZXNoVG9rZW4YASABKAkSNQoGZGV2aWNlGAIgASgLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuTG9naW5EZXZpY2VJbmZvIjoKDUxvZ291dFJlcXVlc3QSEwoLYWNjZXNzVG9rZW4YASABKAkSFAoMcmVmcmVzaFRva2VuGAIgASgJIm4KEkxvZ2luQnlDb2RlUmVxdWVzdBIMCgRjb2RlGAEgASgJEjUKBmRldmljZRgCIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkxvZ2luRGV2aWNlSW5mbxITCgtyZWRpcmVjdFVyaRgDIAEoCUIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM',
    [file_auth_auth_model]
  );

/**
 * @generated from message com.gem.bff.contract.LoginRequest
 */
export type LoginRequest = Message<'com.gem.bff.contract.LoginRequest'> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: com.gem.bff.contract.LoginDeviceInfo device = 3;
   */
  device?: LoginDeviceInfo;
};

/**
 * Describes the message com.gem.bff.contract.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_requests, 0);

/**
 * @generated from message com.gem.bff.contract.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<'com.gem.bff.contract.RefreshTokenRequest'> & {
  /**
   * @generated from field: string refreshToken = 1;
   */
  refreshToken: string;

  /**
   * @generated from field: com.gem.bff.contract.LoginDeviceInfo device = 2;
   */
  device?: LoginDeviceInfo;
};

/**
 * Describes the message com.gem.bff.contract.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_requests, 1);

/**
 * @generated from message com.gem.bff.contract.LogoutRequest
 */
export type LogoutRequest = Message<'com.gem.bff.contract.LogoutRequest'> & {
  /**
   * @generated from field: string accessToken = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refreshToken = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message com.gem.bff.contract.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_requests, 2);

/**
 * @generated from message com.gem.bff.contract.LoginByCodeRequest
 */
export type LoginByCodeRequest = Message<'com.gem.bff.contract.LoginByCodeRequest'> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: com.gem.bff.contract.LoginDeviceInfo device = 2;
   */
  device?: LoginDeviceInfo;

  /**
   * @generated from field: string redirectUri = 3;
   */
  redirectUri: string;
};

/**
 * Describes the message com.gem.bff.contract.LoginByCodeRequest.
 * Use `create(LoginByCodeRequestSchema)` to create a new message.
 */
export const LoginByCodeRequestSchema: GenMessage<LoginByCodeRequest> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_requests, 3);
